import { render, staticRenderFns } from "./AccuntDetail.vue?vue&type=template&id=30d6ebd0&scoped=true&"
import script from "./AccuntDetail.vue?vue&type=script&lang=ts&"
export * from "./AccuntDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AccuntDetail.vue?vue&type=style&index=0&id=30d6ebd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6ebd0",
  null
  
)

export default component.exports